import { Component } from '@angular/core';

@Component({
  selector: 'app-no-matches',
  templateUrl: './no-matches.component.html',
  styleUrls: ['./no-matches.component.scss']
})
export class NoMatchesComponent {

}
